import {createActions} from 'client/framework';

export default createActions(null, ['SAVE_QUESTION_SET', 'SET_QUESTION_SET_UNDER_EDIT']);
